import { DecimalPipe } from '@angular/common';
import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { NguiScrollableModule } from '@ngui/scrollable';
import { scrollTo } from '@ngui/utils';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as _ from 'lodash';

import { SpinnerService } from '@chevtek/angular-spinners';
import { BudgetService } from '../service/budget.service';
import { CompanyService } from '../service/company.service';
import { HomeService } from '../service/home.service';
import { OperatingexpensesService } from '../service/operatingexpenses.service';
import { ProjectService } from '../service/project.service';

import { CashFlowService } from '../service/cashflow.service';
import { UtilsService } from '../service/utils.service';

@Component({
  selector: 'app-projectdata',
  templateUrl: './projectdata.component.html',
  styleUrls: ['./projectdata.component.css'],
})
export class ProjectdataComponent implements OnInit, AfterViewChecked {
  constructor(
    private homeService: HomeService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    private budgetService: BudgetService,
    private operatingexpensesService: OperatingexpensesService,
    private cashflowservice: CashFlowService,
    private spinnerService: SpinnerService,
    private utils: UtilsService
  ) {
    // console.log('Creating ProjectData component');
    this.project_id = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.toastr.setRootViewContainerRef(vRef);
    const flag = true;
    this.showInstructions = false;
    this.isCurrentChecked = false;
    this.isProjectedChecked = false;
    this.isFutureChecked = false;
    // if(!print){
    this.cashflowservice.getCashFlow();
    // }
    this.getCompanyData();
    this.getProjectInfo(flag);
    // this.getCurrentBedRate();
    this.months = [];
    this.months1 = [];
    this.months2 = [];
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() print: boolean;

  @Output() projectEmit: EventEmitter<any> = new EventEmitter();

  @Output() basicEmit: EventEmitter<any> = new EventEmitter();

  @Output() YearlyEmit: EventEmitter<any> = new EventEmitter();

  @Output() roomsEmit: EventEmitter<any> = new EventEmitter();

  @Output() projectInfoEmit: EventEmitter<any> = new EventEmitter();

  // DECLARATION FOR FIXED TABLE SCROLLING
  id = 's1';

  hid = 'h1';

  wid = 'w1';

  // DECLARATION OF ALL VARIABLES
  companyLogoUrl = '';

  companyId = '';

  project_id = '';

  project_notes = '';

  project_name: string;

  licensedBeds: number;

  licensedBedsInitial: number;

  vacancyFactor: number;

  vacancyFactorInitial: number;

  inflationRate: number;

  inflationRateInitial: number;

  foodCost: number;

  foodCostInitial: number;

  selection_type: string;

  bed_rate: number;

  bedRateOther: number;

  bedRateOtherInitial: number;

  applicationFee: number;

  applicationFeeInitial: number;

  otherMonthlyIncome: number;

  otherMonthlyIncomeInitial: number;

  food_cost_operatingExpenses: string;

  startUpMonth: number;

  startUpMonthInitial: number;

  caregiver_day_ratio: any;

  caregivers_per_day: number;

  caregiver_night_ratio: any;

  caregivers_per_night: number;

  averageNightShiftHours: number;

  averageNightShiftHoursInitial: number;

  averageHourlyWage: number;

  averageHourlyWageInitial: number;

  operatingCapital: number;

  operatingCapitalInitial: number;

  maintenanceReserve: number;

  maintenanceReserveInitial: number;

  maintenanceReserveContribution: number;

  maintenanceReserveContributionInitial: number;

  basicData = [];

  basicDataCurrent = [];

  basicDataProjected = [];

  basicDataFuture = [];

  barChartLabels1: string[] = new Array();

  isDataAvailable = false;

  flag = false;

  monthlyBedRate = 0;

  projectedTotal = 0;

  currentTotal: number;

  futureTotal: number;

  currentLicensedBeds: number;

  currentrevenue: number;

  futurerevenue: number;

  futureLicensedBeds: number;

  focus: boolean;

  totalCurrentRevenue = 0;

  totalProjectedRevenue = 0;

  totalFutureRevenue = 0;

  projectedrevenue: number;

  projectedLicensedBeds: number;

  months: number[] = new Array();

  months1: number[] = new Array();

  months2: number[] = new Array();

  projectRoomsArray: string[] = new Array();

  selectionId: string;

  projectType: any;

  // DECLARATION OF GRAPH VARIABLES
  public barChartColors: any[] = [
    {
      backgroundColor: '#FFBE73',
      borderColor: '#FFBE73',
      pointBackgroundColor: '#FFBE73',
      pointBorderColor: '#FFBE73',
      pointHoverBackgroundColor: '#FFBE73',
      pointHoverBorderColor: '#FFBE73',
    },
    {
      backgroundColor: '#7DA7D9',
      borderColor: '#7DA7D9',
      pointBackgroundColor: '#7DA7D9',
      pointBorderColor: '#7DA7D9',
      pointHoverBackgroundColor: '#7DA7D9',
      pointHoverBorderColor: '#7DA7D9',
    },
    {
      backgroundColor: '#FFB3BA',
      borderColor: '#FFB3BA',
      pointBackgroundColor: '#FFB3BA',
      pointBorderColor: '#FFB3BA',
      pointHoverBackgroundColor: '#FFB3BA',
      pointHoverBorderColor: '#FFB3BA',
    },
  ];

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,

    legend: {
      position: 'bottom',
      labels: {
        fontFamily: 'Roboto',
        fontStyle: 'bold',
        fontSize: 15,
        boxWidth: 20,
        padding: 30,
        fontColor: 'black',
        margin: 70,
      },
    },
    tooltips: {
      callbacks: {
        label(tooltipItem, data) {
          return `$${tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            stacked: true,
            fontStyle: 'bold',
            fontSize: 14,
            fontColor: 'black',
            fontFamily: 'Roboto',
            callback(value, index, values) {
              const val = Math.round(value * 10) / 10;
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: 'black',
            fontSize: 17,
            fontStyle: 'bold',
            fontFamily: 'Roboto',
            // callback: function(value, index, values) {
            // return '$' + value;
            // return value.split(" ").join("\n");
            // }
          },
        },
      ],
    },
  };

  public barChartLabels: string[] = new Array();

  public barChartType = 'horizontalBar';

  public barChartLegend = true;

  public bedRoomData = [];

  public bedRoomData1 = [];

  public bedRoomDataPrint = [];

  public bedRoomDataPrint2 = [];

  public barChartData: any[] = new Array();

  pageShow: number = 1;

  ratioMask = [/\d/, /\d/, ':', /\d/];

  // periodMask = '';//[/[1-9]/,/[1-9]/,'.',/[0-9]/,'%']
  changeTimeout: any = {};

  isCurrentChecked: boolean;

  isProjectedChecked: boolean;

  isFutureChecked: boolean;

  labels: string[] = ['Beds Occupied', 'Caregivers Day', 'Caregivers Night'];

  showInstructions: boolean;

  scrollTo(selector, parentSelector, horizontal) {
    scrollTo(
      selector, // scroll to this
      parentSelector, // scroll within (null if window scrolling)
      horizontal, // is it horizontal scrolling
      0 // distance from top or left
    );
    this.hid = selector.split('#').join('');
  }

  ngOnInit() {
    //    console.log('In ngOnInit');
    for (let m = 1; m <= 120; m++) {
      this.months.push(m);
    }
    for (let m = 1; m <= 12; m++) {
      this.months1.push(m);
    }
    for (let m = 13; m <= 24; m++) {
      this.months2.push(m);
    }
    this.getProjectData();
    this.getYearlyRecords();
    this.projectBasicData();
    this.callRevenueFunctions();
    this.projectRooms();
    this.getProjectType();
  }

  // TODO: What is this hook intended to be used for? It is called a ton of times. We only need to add blur handlers once.
  // And it looks like we're copying the text from the Project Notes text area into a div for printing. Can the <textarea> object
  // not handle printing correctly?
  ngAfterViewChecked() {
    this.tabing();
    const textAreaValue = $('#the_textarea').text();
    $('#print_helper').text(textAreaValue);
  }

  getCurrentBedRate() {
    this.isCurrentChecked = true;
  }

  // TO GET SAVED PROJECT DATA FROM PROJECT SERVICE FROM DB
  getProjectData() {
    this.projectService.getProject(this.project_id).subscribe((projectData) => {
      //
      // GENERAL section
      //
      this.licensedBeds = projectData.data[0].licensed_beds;
      this.licensedBedsInitial = this.licensedBeds;

      this.vacancyFactor = projectData.data[0].vacancy_factor;
      this.vacancyFactorInitial = this.vacancyFactor;

      this.inflationRate = projectData.data[0].inflation_rate;
      this.inflationRateInitial = this.inflationRate;

      this.foodCost = projectData.data[0].food_cost;
      this.foodCostInitial = this.foodCost;

      //
      // INCOME section
      //
      this.selection_type = projectData.data[0].selection_type;
      this.bed_rate = projectData.data[0].bed_rate ? projectData.data[0].bed_rate : 0;
      this.bedRateOther = projectData.data[0].bed_rate_other;
      this.bedRateOtherInitial = this.bedRateOther;

      this.applicationFee = projectData.data[0].applicationFee;
      this.applicationFeeInitial = this.applicationFee;

      this.otherMonthlyIncome = projectData.data[0].otherMonthlyIncome;
      this.otherMonthlyIncomeInitial = this.otherMonthlyIncome;

      //
      // CAPITAL ACCOUNTS section
      //
      this.operatingCapital = projectData.data[0].operating_capital;
      this.operatingCapitalInitial = projectData.data[0].operating_capital;

      this.maintenanceReserve = projectData.data[0].maintenance_reserve;
      this.maintenanceReserveInitial = projectData.data[0].maintenance_reserve;

      this.maintenanceReserveContribution = projectData.data[0].maintenance_reserve_contribution;
      this.maintenanceReserveContributionInitial =
        projectData.data[0].maintenance_reserve_contribution;

      //
      // STAFFING section
      //
      this.caregiver_day_ratio = projectData.data[0].caregiver_day_ratio;

      this.caregivers_per_day = projectData.data[0].caregivers_per_day;

      this.caregiver_night_ratio = projectData.data[0].caregiver_night_ratio;

      this.caregivers_per_night = projectData.data[0].caregivers_per_night;

      this.averageNightShiftHours = projectData.data[0].average_night_shift_hours;
      this.averageNightShiftHoursInitial = projectData.data[0].average_night_shift_hours;

      this.averageHourlyWage = projectData.data[0].average_hourly_wage;
      this.averageHourlyWageInitial = projectData.data[0].average_hourly_wage;

      this.startUpMonth = projectData.data[0].start_up_month;
      this.startUpMonthInitial = projectData.data[0].start_up_month;

      this.project_name = projectData.data[0].project_name;
      this.project_notes = projectData.data[0].project_notes;

      this.totalCurrentRevenue = projectData.data[0].total_current_revenue;
      this.totalProjectedRevenue = projectData.data[0].total_projected_revenue;
      this.totalFutureRevenue = projectData.data[0].total_future_revenue;

      if (this.selection_type === 'current') {
        this.isCurrentChecked = true;
      } else if (this.selection_type === 'projected') {
        this.isProjectedChecked = true;
      } else if (this.selection_type === 'future') {
        this.isFutureChecked = true;
      } else if (this.selection_type === 'other') {
        this.flag = true;
      }

      // EMITTER IS USED TO EMIT EVENT WHEN ALL DATA IS LOADED IN CASE OF PRINTING ONLY
      this.projectEmit.emit({ projectEmit: true });
    });
  }

  // TO GET COMPANY LOGO DATA FROM DB THROUGH COMPANY SERVICE
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  projectBasicData() {
    this.projectService.getProjectBasicData(this.project_id).subscribe(
      (res) => {
        this.basicData = res.data;
        let current: number;
        let projected: number;
        let future: number;
        let sum = 0;
        this.basicDataCurrent = [];
        this.basicDataProjected = [];
        this.basicDataFuture = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].type === 'current') {
            this.basicDataCurrent.push(res.data[i]);
            sum = res.data[i].monthly_bed_rate;
            current += sum;
          } else if (res.data[i].type === 'projected') {
            this.basicDataProjected.push(res.data[i]);
            sum = res.data[i].monthly_bed_rate;
            projected += sum;
          } else if (res.data[i].type === 'future') {
            this.basicDataFuture.push(res.data[i]);
            sum = res.data[i].monthly_bed_rate;
            future += sum;
          }
        }

        this.currentTotal = current;
        this.projectedTotal = projected;
        this.futureTotal = future;
        this.basicEmit.emit({ basicEmit: true });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  // TO GET PROJECT ROOMS INFO FROM DB AND SET GRAPH FOR ROOMS
  getProjectInfo(flag) {
    let roomName;
    this.barChartLabels = [];
    this.projectService.getProjectRooms(this.project_id).subscribe(
      (res) => {
        // this.projectRoomsArray = res.data;
        this.barChartLabels1 = [];
        for (const paragraph of res.data) {
          this.barChartLabels1[paragraph._id] = paragraph.room_name;
          if (flag === true) {
            if (paragraph.is_default === 1) {
              // roomName = ['red','green'];
              roomName = [paragraph.room_name, paragraph.short_name];
            } else {
              roomName = paragraph.room_name;
            }
            this.barChartLabels.push(roomName);
          }
        }

        this.projectService.getProjectRevenues(this.project_id).subscribe(
          (res1) => {
            if (res1.data.length > 0) {
              const labelNa = '';
              const barChartData: any = new Array();
              const c: number[] = new Array();
              const p: number[] = new Array();
              const f: number[] = new Array();
              const roomTypes: any = ['Current Revenue', 'Projected Revenue', 'Future Revenue'];
              const i = 1;
              res1.data.forEach((paragraph, index) => {
                const { room_id } = paragraph;

                if (paragraph.type === 'current') {
                  c.push(
                    typeof paragraph.revenue === 'number' && isNaN(paragraph.revenue) === false
                      ? paragraph.revenue
                      : 0
                  );
                } else if (paragraph.type === 'projected') {
                  p.push(
                    typeof paragraph.revenue === 'number' && isNaN(paragraph.revenue) === false
                      ? paragraph.revenue
                      : 0
                  );
                } else if (paragraph.type === 'future') {
                  f.push(
                    typeof paragraph.revenue === 'number' && isNaN(paragraph.revenue) === false
                      ? paragraph.revenue
                      : 0
                  );
                }
              });
              barChartData.push({ data: c, label: 'Current Revenue' });
              barChartData.push({ data: p, label: 'Projected Revenue' });
              barChartData.push({ data: f, label: 'Future Revenue' });
              this.barChartData = barChartData;
              this.isDataAvailable = true;
              this.projectInfoEmit.emit({ projectInfoEmit: true });
            }
          },
          (err) => {
            this.toastr.error(err.message, 'Error');
          }
        );
      },
      (err) => {
        this.toastr.error(err.message, 'Error');
      }
    );
  }

  // TO UPDATE MONTH IN RESIDENTS & STAFF SECTION
  updateStartUpMonth(mon) {
    const data = {
      project_id: this.project_id,
      projectId: this.project_id,
      month: mon,
    };
    this.projectService.updateStartUpMonth(data).subscribe(
      (data) => {
        if (data.status === 'error') {
          // TODO: Can the API still cause this?
          this.toastr.error(data.message, 'Error');
        } else {
          this.startUpMonth = mon;
        }
      },
      (err) => this.toastr.error(err.message, 'Error')
    );
  }

  /* COPY SAME DATA TO ALL 120 MONTHS */
  copyAll() {
    // console.log('[copyAll] Starting function');
    this.spinnerService.show('slowProcesses');
    const bed_rate = this.selection_type === 'other' ? this.bedRateOther : this.bed_rate;
    const data = {
      applicationFee: this.applicationFee,
      average_night_shift_hours: this.averageNightShiftHours,
      averageNightShiftHours: this.averageNightShiftHours,
      avgWage: this.averageHourlyWage,
      bed_rate,
      bedRate: bed_rate,
      food_cost_operatingExpenses: this.foodCost * 30.5,
      foodCostOperatingExpenses: this.foodCost * 30.5,
      inflation_rate: this.inflationRate,
      inflationRate: this.inflationRate,
      licensed_beds: this.licensedBeds,
      licensedBeds: this.licensedBeds,
      otherMonthlyIncome: this.otherMonthlyIncome,
      project_id: this.project_id,
      projectId: this.project_id,
      projectType: this.projectType,
      start_up_month: this.startUpMonth,
      startUpMonth: this.startUpMonth,
      vacancy_factor: this.vacancyFactor,
      vacancyFactor: this.vacancyFactor,
    };
    this.projectService.copyAll(data).subscribe(
      (data) => {
        // console.log('[copyAll] Done with update. Getting yearly records');
        this.getYearlyRecords();
        this.spinnerService.hide('slowProcesses');
        // console.log('[copyAll] Leaving function');
      },
      (err) => {
        this.spinnerService.hide('slowProcesses');
      }
    );
  }

  /* CLEAR DATA OF ALL 120 MONTHS */
  clearAll() {
    this.projectService.clearAll(this.project_id).subscribe(
      (data) => {
        this.getYearlyRecords();
      },
      (err) => {}
    );
  }

  clearBedRates(bed_type) {
    this.projectService.clearBedRates(this.project_id, bed_type).subscribe(
      (data) => {},
      (err) => {
        this.getYearlyRecords();
      }
    );

    this.projectCurrentData();
    this.projectCurrentRevenue(); // TODO: This looks like a bug because projectCurrentData already calls this function

    this.projectProjectedData();
    this.projectProjectedRevenue();

    this.projectFutureData();
    this.projectFutureRevenue();
    this.getProjectInfo(true);
    this.projectBasicData();
  }

  // EXECUTE WHEN BED SELECTION IS CHANGED UNDER DROP DOWN
  onChangeBedType(selectionType) {
    // CONDITIONS TO CHECK WHEATHER BED SELECTION IS OTHER OR NOT BECAUSE OTHER FIELD HAS INPUT ENTRY
    if (selectionType === 'other') {
      this.flag = true;
      setTimeout(function () {
        document.getElementById('bedRateOther').focus();
      }, 100);
      this.isCurrentChecked = false;
      this.isProjectedChecked = false;
      this.isFutureChecked = false;
      const data = {
        fieldName: 'selectionType',
        value1: selectionType,
        value: this.bedRateOther,
        vacancy_factor: this.vacancyFactor,
        vacancyFactor: this.vacancyFactor,
        inflation_rate: this.inflationRate,
        inflationRate: this.inflationRate,
        project_id: this.project_id,
        projectId: this.project_id,
        licensed_beds: this.licensedBeds,
        licensedBeds: this.licensedBeds,
        start_up_month: this.startUpMonth,
        startUpMonth: this.startUpMonth,
        projectType: this.projectType,
      };
      this.projectService.onChangeProject(this.project_id, data).subscribe(
        () => {},
        (err) => {}
      );
    } else {
      this.flag = false;
      if (selectionType === 'current') {
        this.isCurrentChecked = true;
        this.isProjectedChecked = false;
        this.isFutureChecked = false;
        // this.projectCurrentRevenue();
        // this.projectCurrentData();
        this.bed_rate = Math.ceil(this.currentrevenue / this.currentLicensedBeds);
        this.bed_rate = this.bed_rate ? this.bed_rate : 0;
      } else if (selectionType === 'projected') {
        this.isCurrentChecked = false;
        this.isProjectedChecked = true;
        this.isFutureChecked = false;
        // this.projectProjectedData();
        //  this.projectProjectedRevenue();
        this.bed_rate = Math.ceil(this.projectedrevenue / this.projectedLicensedBeds);
        this.bed_rate = this.bed_rate ? this.bed_rate : 0;
      } else if (selectionType === 'future') {
        this.isCurrentChecked = false;
        this.isProjectedChecked = false;
        this.isFutureChecked = true;
        //  this.projectFutureData();
        // this.projectFutureRevenue();
        this.bed_rate = Math.ceil(this.futurerevenue / this.futureLicensedBeds);
        this.bed_rate = this.bed_rate ? this.bed_rate : 0;
      }
      const data = {
        fieldName: 'selectionType',
        value1: selectionType,
        value: this.bed_rate,
        vacancy_factor: this.vacancyFactor,
        vacancyFactor: this.vacancyFactor,
        inflation_rate: this.inflationRate,
        inflationRate: this.inflationRate,
        project_id: this.project_id,
        projectId: this.project_id,
        licensed_beds: this.licensedBeds,
        licensedBeds: this.licensedBeds,
        start_up_month: this.startUpMonth,
        startUpMonth: this.startUpMonth,
        projectType: this.projectType,
      };
      this.projectService.onChangeProject(this.project_id, data).subscribe(
        () => {},
        (err) => {}
      );
    }
  }

  /* SHOW BEDS DATA FOR 120 MONTHS */
  getYearlyRecords() {
    // console.log('[getYearlyRecords] Sending http request');
    this.projectService.getYearlyRecords(this.project_id).subscribe(
      (data) => {
        // console.log('[getYearlyRecords] Got yearly records');
        this.bedRoomData = data.data;
        this.bedRoomData1 = data.data;
        this.bedRoomDataPrint = [];
        this.bedRoomDataPrint2 = [];
        for (let i = 0; i < 12; i++) {
          this.bedRoomDataPrint.push(data.data[i]);
        }
        for (let i = 12; i < 24; i++) {
          this.bedRoomDataPrint2.push(data.data[i]);
        }

        // console.log('[getYearlyRecords] Emitting YearlyEmit event');
        this.YearlyEmit.emit({ YearlyEmit: true });
        // this.bedRoomDataInt = data.data;
      },
      (err) => {}
    );
  }

  getCalculatedYearlyRecords() {
    // console.log('[getCalculatedYearlyRecords] Sending request for calculated yearly records');
    this.projectService.getYearlyRecords(this.project_id).subscribe(
      (data) => {
        // console.log('[getCalculatedYearlyRecords] Got updated yearly records');
        this.bedRoomData1 = data.data;
      },
      (err) => {}
    );
  }

  // EXECUTE WHEN BEDS ARE CHANGED UNDER RESIDENTS & STAFF SECTION OF 120 MONTHS TABLE
  changeBedOccupy($event) {
    // console.log('[changeBedOccupy] Start of call');
    const value = Number($event.event.target.value);
    const _id = $event.event.target.id;
    const { month } = $event;
    if (this.projectType === 'Existing' && month === 0 && value === 0) {
      this.toastr.error(
        'Existing Businesses should have residents in Month 1 or all beds will be charged Referral Fees.'
      );
      return;
    }

    if (this.startUpMonth !== 1 && month + 1 < this.startUpMonth) {
      if (value !== 0) {
        this.toastr.error(
          'You have selected a Start-up Month after beds are occupied, please reselect month or change bed counts.'
        );
      }
      // TODO: This looks suspicious. Why would we set the value in the bedroom data array to 0 if the value passed in wasn't zero?
      // Also, why would we return if the value was 0? Wouldn't we want to still do an update to the database to potentially correct
      // corrupted data?
      this.bedRoomData[month].value = 0;
    } else {
      let caregivers_day;
      let caregivers_night;
      if (value <= this.licensedBeds) {
        if (this.caregivers_per_day === null || this.caregivers_per_night === null) {
          caregivers_day = 0;
          caregivers_night = 0;
        } else {
          const caregiver_day_ratio = Number(this.caregiver_day_ratio.split(':')[0]);
          //          console.log(`[changeBedOccupy] parsed caregiver_day_ratio = ${caregiver_day_ratio}`);
          const caregiver_night_ratio = Number(this.caregiver_night_ratio.split(':')[0]);
          caregivers_day = caregiver_day_ratio === 0 ? 0 : Math.ceil(value / caregiver_day_ratio);
          caregivers_night =
            caregiver_night_ratio === 0 ? 0 : Math.ceil(value / caregiver_night_ratio);
        }
        const foodVal: any = this.foodCost;

        let food_cost_operatingExpenses = 0;
        if (month + 1 >= this.startUpMonth) {
          food_cost_operatingExpenses = foodVal * 30.5;
        }

        const bed_rate = this.selection_type === 'other' ? this.bedRateOther : this.bed_rate;
        const data = {
          applicationFee: this.applicationFee,
          average_hourly_wage: this.averageHourlyWage,
          averageHourlyWage: this.averageHourlyWage,
          average_night_shift_hours: this.averageNightShiftHours,
          averageNightShiftHours: this.averageNightShiftHours,
          beds_occupied: value,
          bedsOccupied: value,
          bed_rate,
          bedRate: bed_rate,
          caregivers_day,
          caregiversDay: caregivers_day,
          caregivers_night,
          caregiversNight: caregivers_night,
          food_cost_operatingExpenses,
          foodCostOperatingExpenses: food_cost_operatingExpenses,
          inflation_rate: this.inflationRate,
          inflationRate: this.inflationRate,
          licensed_beds: this.licensedBeds,
          licensedBeds: this.licensedBeds,
          month,
          otherMonthlyIncome: this.otherMonthlyIncome,
          project_id: this.project_id,
          projectId: this.project_id,
          projectType: this.projectType,
          start_up_month: this.startUpMonth,
          startUpMonth: this.startUpMonth,
          vacancy_factor: this.vacancyFactor,
          vacancyFactor: this.vacancyFactor,
        };
        // if(value >= 0 ||(caregivers_night >=0 && caregivers_day >=0)){
        // console.log('[changeBedOccupy] Sending update yearly record http request');
        this.projectService.updateYearlyRecord(_id, data).subscribe(
          (data) => {
            // console.log('[changeBedOccupy] Updated yearly record. Getting calculated yearly records');
            this.getCalculatedYearlyRecords();
            // console.log('[changeBedOccupy] Leaving function');
          },
          (err) => {
            this.toastr.error(err.message, 'Error');
          }
        );
        // }
      } else {
        this.toastr.error('Occupied beds should not be greater than Licensed beds');
        this.getYearlyRecords();
      }
    }
  }

  // EXECUTE WHEN BED RATES SECTION'S TABLES CHANGED. SAVE VALUES OF BED RATES, BEDS ONCHANGE INTO DB
  changeThis(event, id, val, selectionType) {
    let data;
    const fieldName = event.target.name;
    /* if(fieldName === 'licensed_beds' && val === this.licensed_beds){
      return;
    } */
    if ((fieldName === 'licensed_beds' || fieldName === 'monthly_bed_rate') && val !== null) {
      const value = event.target.value * val;
      data = {
        revenue: 'revenue',
        value,
        id,
        fieldName,
        val: event.target.value,
      };
    } else {
      data = {
        id,
        fieldName,
        val: event.target.value,
      };
    }

    this.projectService.updateBedRates(data).subscribe(
      (data) => {
        if (selectionType === 'current') {
          this.projectCurrentData();
        } else if (selectionType === 'projected') {
          this.projectProjectedData();
        } else if (selectionType === 'future') {
          this.projectFutureData();
        }
      },
      (err) => {}
    );
  }

  // TO UPDATE TOTALS OF BEDS UNDER CURRENT SELECTION INTO DB
  projectCurrentData() {
    this.projectService.projectCurrentData(this.project_id).subscribe(
      async (data) => {
        if (data.data === null) {
          data.data = 0;
        }
        this.currentLicensedBeds = parseInt(data.data);
        if (this.licensedBeds && this.currentLicensedBeds > this.licensedBeds) {
          this.toastr.error('Total Beds Exceeds Licensed Beds');
        }
        await this.projectCurrentRevenue();
      },
      (err) => {}
    );
  }

  // TO UPDATE TOTAL REVENUES UNDER CURRENT SELECTION INTO DB
  projectCurrentRevenue() {
    this.projectService.projectCurrentRevenue(this.project_id).subscribe(
      (data) => {
        if (data.data === null) {
          data.data = 0;
        }
        this.currentrevenue = parseInt(data.data, 10);
        this.totalCurrentRevenue =
          this.currentLicensedBeds !== 0
            ? Math.ceil(this.currentrevenue / this.currentLicensedBeds)
            : 0;
        this.totalCurrentRevenue = this.totalCurrentRevenue ? this.totalCurrentRevenue : 0;
        let data1;
        data1 = {
          fieldName: 'totalCurrentRevenue',
          value: this.totalCurrentRevenue,
        };
        this.projectService.onChangeProject(this.project_id, data1).subscribe(
          (data) => {},
          (err) => {}
        );

        if (this.selection_type === 'current') {
          this.bed_rate = this.totalCurrentRevenue;
          // TODO: This looks wrong. Why are we updating the selection_type when selection_type has not changed? The bed_rate needs to be
          // updated, however.
          data1 = {
            fieldName: 'selectionType',
            value1: this.selection_type,
            value: this.bed_rate,
            vacancy_factor: this.vacancyFactor,
            vacancyFactor: this.vacancyFactor,
            inflation_rate: this.inflationRate,
            inflationRate: this.inflationRate,
            project_id: this.project_id,
            projectId: this.project_id,
            licensed_beds: this.licensedBeds,
            licensedBeds: this.licensedBeds,
            start_up_month: this.startUpMonth,
            startUpMonth: this.startUpMonth,
            projectType: this.projectType,
          };
          // data1={'fieldName': 'bedRate','value': this.totalCurrentRevenue}
          this.projectService.onChangeProject(this.project_id, data1).subscribe(
            (data) => {},
            (err) => {}
          );
        }
      },
      (err) => {}
    );
  }

  // TO UPDATE TOTALS OF BEDS UNDER PROJECTED SELECTION INTO DB
  projectProjectedData() {
    this.projectService.projectProjectedData(this.project_id).subscribe(
      async (data) => {
        if (data.data === null) {
          data.data = 0;
        }
        this.projectedLicensedBeds = parseInt(data.data);
        if (this.projectedLicensedBeds > this.licensedBeds) {
          this.toastr.error('Total Beds Exceeds Licensed Beds');
        }
        await this.projectProjectedRevenue();
      },
      (err) => {}
    );
  }

  // TO UPDATE TOTAL REVENUES UNDER PROJECTED SELECTION INTO DB
  projectProjectedRevenue() {
    this.projectService.projectProjectedRevenue(this.project_id).subscribe(
      (data) => {
        if (data.data === null) {
          data.data = 0;
        }
        this.projectedrevenue = parseInt(data.data);
        this.totalProjectedRevenue = Math.ceil(this.projectedrevenue / this.projectedLicensedBeds);
        this.totalProjectedRevenue = this.totalProjectedRevenue ? this.totalProjectedRevenue : 0;
        let data1 = {};
        data1 = { fieldName: 'totalProjectedRevenue', value: this.totalProjectedRevenue };
        this.projectService.onChangeProject(this.project_id, data1).subscribe(
          (data) => {},
          (err) => {}
        );

        if (this.selection_type === 'projected') {
          this.bed_rate = this.totalProjectedRevenue;
          data1 = {
            fieldName: 'selectionType',
            value1: this.selection_type,
            value: this.bed_rate,
            vacancy_factor: this.vacancyFactor,
            vacancyFactor: this.vacancyFactor,
            inflation_rate: this.inflationRate,
            inflationRate: this.inflationRate,
            project_id: this.project_id,
            projectId: this.project_id,
            licensed_beds: this.licensedBeds,
            licensedBeds: this.licensedBeds,
            start_up_month: this.startUpMonth,
            startUpMonth: this.startUpMonth,
            projectType: this.projectType,
          };
          // data1={'fieldName': 'bedRate','value': this.totalProjectedRevenue}
          this.projectService.onChangeProject(this.project_id, data1).subscribe(
            () => {},
            (err) => {}
          );
        }
      },
      (err) => {}
    );
  }

  // TO UPDATE TOTALS OF BEDS UNDER FUTURE SELECTION INTO DB
  projectFutureData() {
    this.projectService.projectFutureData(this.project_id).subscribe(
      async (data) => {
        if (data.data === null) {
          data.data = 0;
        }
        this.futureLicensedBeds = parseInt(data.data);
        if (this.futureLicensedBeds > this.licensedBeds) {
          this.toastr.error('Total Beds Exceeds Licensed Beds');
        }
        await this.projectFutureRevenue();
      },
      (err) => {}
    );
  }

  // TO UPDATE TOTAL REVENUES UNDER FUTURE SELECTION INTO DB
  projectFutureRevenue() {
    this.projectService.projectFutureRevenue(this.project_id).subscribe(
      (data) => {
        if (data.data === null) {
          data.data = 0;
        }
        this.futurerevenue = parseInt(data.data);
        this.totalFutureRevenue = Math.ceil(this.futurerevenue / this.futureLicensedBeds);
        this.totalFutureRevenue = this.totalFutureRevenue ? this.totalFutureRevenue : 0;
        // this.bed_rate = this.totalFutureRevenue;
        let data1 = {};
        data1 = { fieldName: 'totalFutureRevenue', value: this.totalFutureRevenue };
        this.projectService.onChangeProject(this.project_id, data1).subscribe(
          (data) => {},
          (err) => {}
        );

        if (this.selection_type === 'future') {
          this.bed_rate = this.totalFutureRevenue;
          data1 = {
            fieldName: 'selectionType',
            value1: this.selection_type,
            value: this.bed_rate,
            vacancy_factor: this.vacancyFactor,
            vacancyFactor: this.vacancyFactor,
            inflation_rate: this.inflationRate,
            inflationRate: this.inflationRate,
            project_id: this.project_id,
            projectId: this.project_id,
            licensed_beds: this.licensedBeds,
            licensedBeds: this.licensedBeds,
            start_up_month: this.startUpMonth,
            startUpMonth: this.startUpMonth,
            projectType: this.projectType,
          };
          // data1 = {'fieldName': 'bedRate','value': this.totalFutureRevenue}
          this.projectService.onChangeProject(this.project_id, data1).subscribe(
            () => {},
            (err) => {}
          );
        }
      },
      (err) => {}
    );
  }

  // EXECUTE WHEN ADD OTHER BUTTON CLICKED TO ADD NEW ENTRY FOR A NEW ROOM INTO DB
  addOtherRoom() {
    let array = [];
    this.projectService.addRoom(this.project_id).subscribe(
      (data) => {
        this.projectRooms().then((success) => {
          array = this.projectRoomsArray;
          setTimeout(function () {
            document.getElementById(`label${array.length}`).focus();
          }, 1500);
        });
        this.projectBasicData();
      },
      (err) => {}
    );
  }

  // GET ALL PROJECT ROOMS ENTRY
  projectRooms(): Promise<Boolean> {
    const self = this;
    return new Promise((resolve, reject) => {
      this.projectService.getProjectRooms(this.project_id).subscribe(
        (data) => {
          this.projectRoomsArray = data.data;
          this.roomsEmit.emit({ roomsEmit: true });
        },
        (err) => {}
      );
      resolve(true);
    });
  }

  // EXECUTE ONCHANGE OF INPUT OF ADD OTHER ROOM TO SAVE ROOM NAMES INTO DB
  saveRoomName(event, room_id) {
    const { value } = event.target;
    this.projectService.saveRoomName(room_id, value).subscribe(
      (data) => {
        this.getProjectInfo(true);
      },
      (err) => {}
    );
  }

  // EXECUTE WHEN PROJECT NOTES ARE UPDATED
  saveProjectNotes(event) {
    const data = {
      fieldName: 'projectNotes',
      value: event.target.value,
    };
    this.projectService.saveProjectNotes(this.project_id, data).subscribe(
      (res) => {
        if (res.messageId === 200) {
        } else if (res.messageId === 400) {
          // TODO: Can the API still cause this?
          this.toastr.error(res.message, 'Error!');
        }
      },
      (err) => {
        this.toastr.error(err.message, 'Error!');
      }
    );
  }

  // REMOVE AN ENTRY FROM DB OF ROOM WHEN CLICKED ON TRASH BUTTON
  removeRoom(room_id) {
    this.projectService.removeRoom(room_id).subscribe(
      (data) => {
        this.projectRooms();
        this.getProjectInfo(true);
        this.projectBasicData();
        this.callRevenueFunctions();
      },
      (err) => {}
    );
  }

  // Open instructions popup to show instructions from corresponding page
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  closeInstructions() {
    this.showInstructions = false;
  }

  // COMBINE ALL REVENUES FUNCTIONS INTO ONE SO THAT CALL TO ALL FUNCTIONS BECOME EASY
  callRevenueFunctions() {
    this.projectCurrentData();
    this.projectProjectedData();
    this.projectFutureData();
  }

  // -------------------------------------------------------------------------------------------------

  updateCaregiverRatio(ratio: string, lowerCaregiverField: string, titleCaregiverField: string) {
    const thisRatioFieldName = `caregiver_${lowerCaregiverField}_ratio`;
    const thisCaregiverCountFieldName = `caregivers_per_${lowerCaregiverField}`;
    //    console.log(`[updateValue] Before any processing, stored ratio is '${this[thisRatioFieldName]}'`);
    //    console.log(`Ratio: '${ratio}'`);

    //
    // Start by splitting the entered value at the colon. The only time there isn't a colon is if someone deletes the entire value and
    // moves the cursor out of the input.
    // TODO: If that happens, will we get a value in "split" at all?
    const split = ratio.split(':');
    //    console.log(`split = ${split}`);
    //
    // If someone has only entered the first part of the ratio, default the second part of the ratio to :1. The mask applied to the text
    // control is basically "__:_", so the part after the colon would be a space if nothing has been entered.
    //
    if (!_.isNil(split[0]) && split[1] === ' ') {
      split[1] = '1';
      this[thisRatioFieldName] = `${split[0]}:${split[1]}`;
    }

    //
    // For each element in the split value, convert the value to a number.
    //
    const ratioComponents = [];
    for (let index = 0; index < split.length; index++) {
      //      console.log(`ratio[${index}] before conversion: ${split[index]}`);
      ratioComponents.push(Number(split[index]));
      //      console.log(`ratio[${index}] after conversion: ${ratioComponents[index]}`);
    }

    //
    // If we didn't get a second number in the ratio, default to :1.
    //
    if (ratioComponents.length === 1) {
      //      console.log('[updateValue] Nothing in second part of ratio');
      ratioComponents.push(1);
    }

    //
    // If a 0 was entered in either half of the ratio, tell the user this is invalid.
    //
    if (ratioComponents[0] === 0 || ratioComponents[1] === 0) {
      this.toastr.error('The ratio cannot have a 0 in either part. Please enter a positive value.');
      return;
    }

    //
    // Update the ratio value using the numerator from the original string so that the location of the space is preserved.
    // We don't care if someone enters " 5:1" or "5 :1", but we would like to preserve it. Optionally, we could always force the space
    // to be the first character if the numerator is less than 10.
    //
    this[thisRatioFieldName] = `${split[0]}:${ratioComponents[1]}`;
    //    console.log(`Set ${thisRatioFieldName} to ${this[thisRatioFieldName]}`);

    //
    // The number of caregivers should take into account the entire ratio as a fraction, so we handle values like 3:2.
    // 12 * 3
    this[thisCaregiverCountFieldName] = Math.ceil(
      (this.licensedBeds * ratioComponents[1]) / ratioComponents[0]
    );
    //    console.log(`Calculated caregivers per day: ${this[thisCaregiverCountFieldName]}`);
    this[thisCaregiverCountFieldName] = this[thisCaregiverCountFieldName]
      ? this[thisCaregiverCountFieldName]
      : 0;
    //    console.log(`Caregivers per day after forcing to valid value: ${this[thisCaregiverCountFieldName]}`);
    //    console.log(`[updateValue] After all processing, stored ratio is '${this[thisRatioFieldName]}'`);

    const data = {
      fieldName1: `caregiver${titleCaregiverField}Ratio`,
      value1: this[thisRatioFieldName],
      fieldName2: `caregiversPer${titleCaregiverField}`,
      value2: this[thisCaregiverCountFieldName],
      vacancy_factor: this.vacancyFactor,
      vacancyFactor: this.vacancyFactor,
      project_id: this.project_id,
      projectId: this.project_id,
      licensed_beds: this.licensedBeds,
      licensedBeds: this.licensedBeds,
      bed_rate: this.selection_type === 'other' ? this.bedRateOther : this.bed_rate,
      bedRate: this.selection_type === 'other' ? this.bedRateOther : this.bed_rate,
      start_up_month: this.startUpMonth,
      startUpMonth: this.startUpMonth,
      inflation_rate: this.inflationRate,
      inflationRate: this.inflationRate,
      average_night_shift_hours: this.averageNightShiftHours,
      averageNightShiftHours: this.averageNightShiftHours,
      avgWage: this.averageHourlyWage,
      projectType: this.projectType,
    };

    this.projectService.onChangeProject(this.project_id, data).subscribe(
      () => {
        this.getYearlyRecords();
      },
      (err) => {
        this.toastr.error(err.message, 'Error');
      }
    );
  }

  // -------------------------------------------------------------------------------------------------

  // EXECUTE WHEN PARAMETERS ARE CHANGED AND SAVE FIELD VALUES ONCHANGE OF INPUTS INTO DB
  updateValue(event) {
    const fieldName = event.target.name;

    // CONDITIONS ARE DEFINED BECAUSE ON EACH FIELD THERE ARE SOME CALCULATIONS
    if (event.target.name === 'caregiverDayRatio') {
      return this.updateCaregiverRatio(event.target.value, 'day', 'Day');
    }

    if (event.target.name === 'caregiverNightRatio') {
      return this.updateCaregiverRatio(event.target.value, 'night', 'Night');
    }

    try {
      //
      // First, get the new value that was passed in as a Number without any of the special characters.
      //
      const value = Number(this.replaceDollarsCommasPercentages(event.target.value));

      //
      // Validate that the Number is not NaN. If it is, throw an error that includes the field name in "start case", e.g. "Vacancy Factor".
      //
      this.utils.validateNumberField(value, _.startCase(fieldName));

      //
      // If the value didn't change, there's nothing for us to do here so return immediately.
      //
      if (value === this[`${fieldName}Initial`]) {
        return;
      }

      const data = {
        applicationFee: this.applicationFee,
        average_night_shift_hours: this.averageNightShiftHours,
        averageNightShiftHours: this.averageNightShiftHours,
        avgWage: this.averageHourlyWage,
        bed_rate: this.selection_type === 'other' ? this.bedRateOther : this.bed_rate,
        bedRate: this.selection_type === 'other' ? this.bedRateOther : this.bed_rate,
        fieldName,
        foodCost: this.foodCost,
        inflation_rate: this.inflationRate,
        inflationRate: this.inflationRate,
        licensed_beds: this.licensedBeds,
        licensedBeds: this.licensedBeds,
        otherMonthlyIncome: this.otherMonthlyIncome,
        project_id: this.project_id,
        projectId: this.project_id,
        projectType: this.projectType,
        start_up_month: this.startUpMonth,
        startUpMonth: this.startUpMonth,
        vacancy_factor: this.vacancyFactor,
        vacancyFactor: this.vacancyFactor,
        value,
      };

      if (event.target.name === 'licensedBeds') {
        //
        // If the number of beds in any of the Bed Rates tables lower on the page have more beds than the new value specified in the
        // licensed beds input, tell them to fix the tables first, reset the value in the Licensed Beds entry, and then bail.
        //
        const bedCountArray: any = [
          this.currentLicensedBeds,
          this.projectedLicensedBeds,
          this.futureLicensedBeds,
        ];
        const maxBedsAllowed = Math.max.apply(null, bedCountArray);
        if (value < maxBedsAllowed) {
          this.toastr.error(
            'The number of beds specified in the Bed Rate details below exceed the new number of licensed beds. Please lower the number of beds in the Bed Rates tables first.'
          );

          this.licensedBeds = this.licensedBedsInitial;
          return;
        }
        // BUG: Everywhere else, the caregiver_day_ratio is actually the ratio STRING with the ':' in it. Instead of doing this logic
        // here, we should be able to reuse the logic for calculating the number of caregivers per day and night whether someone changes
        // the actual ratios or the number of licensed beds.
        let ratio = this.caregiver_day_ratio ? this.caregiver_day_ratio : 0;
        if (ratio === 0) {
          this.caregivers_per_day = this.caregivers_per_day ? this.caregivers_per_day : 0;
        } else {
          const split = ratio.split(':');
          this.caregivers_per_day = Math.ceil(value / split[0]);
          this.caregivers_per_day = this.caregivers_per_day ? this.caregivers_per_day : 0;
        }

        ratio = this.caregiver_night_ratio ? this.caregiver_night_ratio : 0;
        if (ratio === 0) {
          this.caregivers_per_night = 0;
        } else {
          const split = ratio.split(':');
          this.caregivers_per_night = Math.ceil(value / split[0]);
          this.caregivers_per_night = this.caregivers_per_night ? this.caregivers_per_night : 0;
        }

        data['fieldName1'] = 'caregiversPerDay';
        data['value1'] = this.caregivers_per_day;
        data['fieldName2'] = 'caregiversPerNight';
        data['value2'] = this.caregivers_per_night;
      } else if (event.target.name === 'averageNightShiftHours') {
        //
        // If someone has entered more than 12 hours in a night shift, we need to inform them that that is not allowed, reset the value
        // shown in the UI, and bail.
        // TODO: We should really enforce this with a maximum value specified in the HTML.
        //
        if (value > 12) {
          this.averageNightShiftHours = this.averageNightShiftHoursInitial;
          this.toastr.error(
            'The night shift cannot be more than 12 hours. Please enter a smaller value.'
          );
          return;
        }
      }

      //
      // Send the data change to the API.
      //
      this.projectService.onChangeProject(this.project_id, data).subscribe(
        () => {
          //
          // After we know the value was updated correctly, store the new saved value for future comparisons.
          //
          this[`${fieldName}Initial`] = value;

          //
          // If the number of licensed beds was changed, we also need to re-read the monthly records because they contain any adjustments
          // to the number of caregivers in any given month that are displayed on this page.
          //
          if (event.target.name === 'licensedBeds') {
            this.getYearlyRecords();
          }
        },
        (err) => {
          //
          // If an error occurred when saving the value, set the value shown in the UI back to the origial value, and then
          // display a toast for the user to know the save wasn't successful.
          //
          this[`${fieldName}`] = this[`${fieldName}Initial`];
          this.toastr.error(err.message, 'Error');
        }
      );
    } catch (ex) {
      this.toastr.error(ex.message, 'Error');
    }
  }

  // TO REMOVE DOLLER AND COMMAS FROM VALUES
  replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // THIS FUNCTIONS IS TO CHANGE OF TABING IN BED RATES SECTIONS'S TABING
  tabing() {
    $('.current-entry').each(function (i, obj) {
      $(obj).blur(function () {
        $(`#label${$(this).attr('id')}`).focus();
      });
    });

    $('.other_button').each(function (i, obj) {
      $(obj).blur(function () {
        $(`#${$(this).attr('id').replace('label', 'input')}`).focus();
      });
    });
  }

  getProjectType() {
    const data = {
      project_id: this.project_id,
      projectId: this.project_id,
    };
    this.projectService.getProjectType(data).subscribe((projectTypeData) => {
      this.projectType = projectTypeData.data[0].business_type;
    });
  }

  refreshGraph() {
    const flag = true;
    this.getProjectInfo(flag);
  }
}



// WEBPACK FOOTER //
// ./src/app/projectdata/projectdata.component.ts